module.exports = __webpack_public_path__ + "static/media/wiz-old.ba8532b6.png";